<div class="row" [style]="'height: ' + chartHeight + 'vh;'">
    <canvas baseChart [data]="chartData" [type]="chartConfig.type === 'pie' ? 'pie' : 'doughnut'" [options]="chartOptions"></canvas>
</div>
